import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '@core/store/hooks';
import { selectCurrentProject } from '@features/projects';
import { DocumentPreviewModal } from '@features/dataroom';

import { selectPreviewDocument, closePreview, sendToCanvas } from '../store/workspaceSlice';

export function QuickPreview() {
  const dispatch = useAppDispatch();
  const previewDocument = useAppSelector(selectPreviewDocument);
  const currentProject = useAppSelector(selectCurrentProject);

  const handleSendToCanvas = useCallback(() => {
    dispatch(sendToCanvas());
  }, [dispatch]);

  return (
    <DocumentPreviewModal
      document={previewDocument}
      projectUuid={currentProject?.uuid || null}
      isOpen={!!previewDocument}
      onClose={() => dispatch(closePreview())}
      onSendToCanvas={handleSendToCanvas}
    />
  );
}
